import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

import { FavoriteDirective } from './directives/favorite.directive';
import { BlurComponent } from './blur';
import { BusinessValidatorDirective } from './directives/business-validator.directive';
import { PersonalInformationComponent } from './components/personal-information';
import { SearchBoxComponent } from './search-box';
import { EmailBoxComponent } from './email-box';
import { PlansSideBarComponent } from './components/plans-side-bar';
import { CarrierPerformanceComponent } from './components/carrier-performance';
import { VoyagePartialComponent } from './components/voyage-partial';
@NgModule({
  imports: [FormsModule, CommonModule, ReactiveFormsModule, RouterModule],
  declarations: [BlurComponent, BusinessValidatorDirective, FavoriteDirective, PersonalInformationComponent, SearchBoxComponent, EmailBoxComponent, PlansSideBarComponent, CarrierPerformanceComponent, VoyagePartialComponent],
  exports: [FormsModule, ReactiveFormsModule, BlurComponent, FavoriteDirective, PersonalInformationComponent, SearchBoxComponent, EmailBoxComponent, PlansSideBarComponent, CarrierPerformanceComponent, VoyagePartialComponent]
})

export class SharedModule { }


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/shared.module.ts